// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"6a7dbd4a","787":"5dffbaaa"}[chunkId] + ".chunk.js";
};